import DialogContent from "./DialogContent";
import DialogActions from "./DialogActions";

export { DialogContent, DialogActions };



// WEBPACK FOOTER //
// ./src/components/app/registration/company/form/integrations/oms/dialog/index.js